import { Store } from "../../../client/stores";
import { PageBlockRegistry } from "../page-blocks/Block.component";

export const getBlockComponents = (
    store: Store,
    blockComponents: PageBlockRegistry,
    micrositeComponents: PageBlockRegistry,
) => (store.microsite ? micrositeComponents : blockComponents);
